module.exports = {
    URL: 'https://api.ecomtechbd.com',
};
// module.exports = {
//     URL: 'http://localhost:4002',
// };
